<template>
  <base-container :isLoading="isLoading">
    <!-- <van-nav-bar title="当日挂号" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
    <div id="appdiv">
      <div class="container">
        <div class="Appointment">
          <header>
            <div class="top-bar">
              <ul>
                <li :class="{check:checkRegNoType==0}" @click="checkRegNum(0)">普通号</li>
                <li :class="{check:checkRegNoType==2}" @click="checkRegNum(2)">专家号</li>
              </ul>
            </div>
          </header>
          <van-tree-select :items="items" height="100%" :active-id.sync="activeId" :main-active-index.sync="mainIndex"
            @click-nav="changeOrg">
            <template #content>
              <van-empty class="custom-image" v-if="isShowDept== 1" image="../../images/01.png" description="暂无科室" />
              <van-list v-if="isShowDept== 0" v-model="loading" :finished="finished" @load="changeOrg"
                finished-text="没有更多了">
                <van-cell v-for="item in selOrg.children" :key="item.id" :title="item.text" @click="selDept(item)" />
              </van-list>
            </template>
          </van-tree-select>
        </div>
      </div>
    </div>
  </base-container>
</template>

<script>
  import "@/assets/css/reset.css";
  import "@/assets/css/comman.css";
  import "@/assets/css/Appointment.css";
  // import { Notify } from 'vant';
  import { GetRegisterDeptList } from "@/api/hos";

  export default {
    data() {
      return {
        isLoading: false,
        loading: false,
        finished: false,
        items: [
          {
            text: "龙门院区",
            children: [],
            id: "01"
          },
          {
            text: "季梁院区",
            children: [],
            id: "02"
          },
          {
            text: "文帝院区",
            children: [],
            id: "03"
          }
        ],
        activeId: "04",
        mainIndex: 0,
        isShowDept: 0,//0有科室数据 1无
        checkRegNoType: 0,//2专家号 0普通号
        queryParams: {
          OrgCode: undefined,
          DeptType: undefined
        },
      };
    },
    computed: {
      selOrg() {
        return this.items[this.mainIndex];
      }
    },
    created() {
      //this.changeOrg();
    },
    methods: {
      checkRegNum(type) {
        if (type == 0) {
          this.checkRegNoType = 0;
          this.changeOrg();
        }
        else {
          this.checkRegNoType = 2;
          this.changeOrg();
        }
      },
      changeOrg() {
        this.selOrg.children = [];
        if (this.selOrg.children.length == 0) {
          this.isLoading = true;
          this.queryParams.OrgCode = this.selOrg.id;
          this.queryParams.NoType = this.checkRegNoType;
          GetRegisterDeptList(this.queryParams).then(res => {
            if (res.data.value != null && res.data.value.length > 0) {
              this.isShowDept = 0;
              this.loading = false;
              this.finished = true;
              res.data.value.forEach(item => {
                this.selOrg.children.push({
                  id: item.deptCode,
                  text: item.deptName
                });
              });
            }
            else {
              this.isShowDept = 1;
              // Notify({
              //   type: 'danger',
              //   message: res.data.msg
              // });
            }
            this.isLoading = false;
          }).catch(() => {
            this.isLoading = false;
          });
        }
      },
      selDept(item) {
        this.toPage("hosregisterdoctor", { noType: this.checkRegNoType, orgCode: this.selOrg.id, deptCode: item.id });
      },
      toPage(name, params) {
        this.$router.push({ name, params });
      }
    }
  };
</script>

<style>
  .custom-image .van-empty__image {
    width: 90px !important;
    height: 44px !important;
  }
</style>